<section class="ft-master-section ft-campaign-master">
  <ft-pending-changes-panel-ng #panel [live]="model().campaign" [inactive]="panelInactive" (save)="onPanelSave()" (cancelled)="onPanelCancel()" />

  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-row">
        <div class="ft-col-33">
          <div class="ft-section-header">
            <div class="ft-label">{{ 'flipto.account.platform.preStay.campaign.Goals' | translate }}</div>
            <p class="ft-summary">{{ goalsSummaryKey() | translate }}</p>
          </div>
        </div>
        <div class="ft-col-66">
          <ft-campaign-goals-ng [campaign]="model().campaign" [propertyIncentives]="propertyIncentives()"
                                [culture]="selectedLanguage()" [layer]="layerName()"
                                (editGoals)="onEditGoals($event)" />
        </div>
      </div>
    </div>
  </section>
</section>

<!-- ftModal phase 2 / WS3: the campaign goals (editCampaignGoals) modal, native. Replaces the
     bridged EDIT_CAMPAIGN_GOALS_MODAL compile (ft-edit-campaign-goals / ft-goal-selector /
     ft-incentive-selector are now native -ng). DEFERRED-save: the modal mutates
     model.campaign.goals.item in place; on Done we call panel.recompute() so the NATIVE
     pending-changes panel (above) detects the change via native-diff (no AngularJS digest /
     homepage trap). v1 had ft-snapshot="model.campaign.goals.item" → X/Cancel reverts the array. -->
<ft-modal-overlay [open]="goalsModalOpen()">
  @if (goalsModalOpen()) {
    <ft-modal-chrome-ng
      [headerText]="types() && types().length ? (types()[0] | editGoalsTitle: layerName()) : ''"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onGoalsDone()"
      (cancel)="onGoalsCancel()"
    >
      <ft-edit-campaign-goals-ng [goals]="model().campaign?.goals?.item"
        [incentives]="propertyIncentives()"
        [culture]="selectedLanguage()"
        [types]="types()"
        [incentiveTag]="incentiveTag()"
       />
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>
